export const EXTERNAL_PRESENCE_APP_URL =
  (import.meta.env.VITE_PRESENCE_APP_URL as string | undefined)?.trim() ||
  'https://epd-ppe.porr-itservices.com/';
